import baseService from '@common/services/base.service';
import store from '@common/store/store';

const tbRoute = window.api_routes.smarAPD_Tributario_Domain;

let http = baseService(store, tbRoute);

const apiDef = {
  GetByCgcCpf(cpfCnpj) {
    return http.get(`/ContribuinteExterno/GetByCpfCnpj`, {
      params: {
        cpfCnpj
      }
    })
  },
};

export default apiDef;
